import { structureTypeOf, type StructureType } from "@tasduvar/engine";
import { t } from "../../i18n";
import type { ReportModel } from "./model";

export interface CoverText { subtitle: string; title: string; docNo?: string; reviewer?: string; firm?: { name?: string; address?: string; phone?: string; email?: string }; logoDataUrl?: string; showSignatures: boolean; note?: string; footerExtra: string }

/** Duvar tiplerine göre üst başlık: tek tip ise adı, karışıksa genel. */
export function defaultSubtitle(types: StructureType[]): string {
  const set = new Set(types);
  if (set.size === 1) {
    const only = [...set][0]!;
    return only === "masonry-gravity" ? t("TAŞ (KARGİR) AĞIRLIK İSTİNAT DUVARI") : only === "rc-counterfort" ? t("BETONARME PAYANDALI İSTİNAT DUVARI") : t("BETONARME KONSOL İSTİNAT DUVARI");
  }
  return t("İSTİNAT DUVARLARI");
}

/** Kapak metinleri: proje künyesindeki `cover` alanları varsayılanların üstüne yazar; logo yoksa sağlayıcı logosu. Rapor (HTML) ve Word ortak. */
export function coverText(m: ReportModel): CoverText {
  const c = m.project.info.cover;
  const subtitle = c?.subtitle?.trim() || defaultSubtitle(m.walls.map((w) => structureTypeOf(w.wall.geometry)));
  const title = c?.title?.trim() || t("Statik ve Depremli Stabilite Analizi Raporu");
  const firm = c?.firm && Object.values(c.firm).some((v) => v && v.trim()) ? c.firm : undefined;
  const footerExtra = [c?.docNo ? `${t("Belge no")} ${c.docNo}` : "", firm?.name ?? ""].filter(Boolean).join(" · ");
  return { subtitle, title, docNo: c?.docNo || undefined, reviewer: c?.reviewer || undefined, firm, logoDataUrl: c?.logoDataUrl || m.branding.logoDataUrl, showSignatures: c?.showSignatures ?? true, note: c?.note || undefined, footerExtra };
}
